module.exports = __webpack_public_path__ + "img/logo.41ed89fc.png";